export default __webpack_public_path__ + "static/media/pic63.9c99694b.jpg";